import PropTypes from 'prop-types';
import styled from 'styled-components';
import { GridContentMixin } from '../../mixins/components/GridContentMixin';
import { Grid } from '../Grid/Grid';

/**
 * Grid content is a specialized grid item used primariliy for visually containing content within
 * the context of a `Page` component
 * (i.e. providing a background and padding). If you need grid functionality without any
 * visual treatment, you can simply use a `Grid` component
 * instead.
 *
 * This component extends the `Grid` component which has limited
 * support for IE11. See the `Grid` component for more details.
 *
 * @extends Grid
 * @since 8.22.0
 */
var GridContent = /*#__PURE__*/styled(Grid).withConfig({
  displayName: "GridContent",
  componentId: "c11n-8-111-1__sc-14ral2z-0"
})(["", ""], GridContentMixin);
GridContent.displayName = 'GridContent';
GridContent.propTypes = {
  /**
   * A color token or `null` to remove the default background color.
   */
  backgroundColor: PropTypes.string,
  /**
   * Sets the padding of the content component.
   */
  padding: PropTypes.string
};
GridContent.defaultProps = {
  padding: 'sm'
};

/** @component */
export { GridContent };